import React, { lazy } from "react";

const PushCentersPage = lazy(() => import("./PushCentersPage"));

const pushCentersRoute = {
  path: "push_centers",
  element: <PushCentersPage />,
  root: true,
  permission: "ui_view_push_centers",
};

export default pushCentersRoute;
